import InfoIcon from "@mui/icons-material/Info"
import MoreVertIcon from "@mui/icons-material/MoreVert"
import { Menu, MenuItem } from "@mui/material"
import IconButton from "@mui/material/IconButton"
import { AssignLicenseDialog } from "components/License/AssignLicenseDialog"
import { CancelLicenseDialog } from "components/License/CancelLicenseDialog"
import { useAppSelector } from "hooks"
import { useState } from "react"
import { useNavigate } from "react-router-dom"
import type { ILicense } from "types/licenseTypes"
import type { IUser } from "types/userTypes"
import { DeleteUserDialog } from "./DeleteUserDialog"
import { UpdateUserDialog } from "./UpdateUserDialog"

type Props = {
  user: IUser
}

export function UserListItemMenu({ user }: Props) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const [openMenu, setOpenMenu] = useState(false)
  const [license, setLicense] = useState<ILicense | undefined>(undefined)

  const navigate = useNavigate()

  const licenses = useAppSelector((state) => state.license.licenses)

  const handleMenuClose = () => {
    setAnchorEl(null)
    setOpenMenu(false)
  }

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
    setOpenMenu(true)
    setLicense(licenses.find((x) => x.assignedUserId === user.id))
  }
  const handleClickUserDetails = (_event: React.MouseEvent<HTMLElement>) => {
    navigate(`/user/${user.id}`)
  }

  return (
    <>
      <IconButton aria-label="edit" size="small" onClick={handleMenuOpen}>
        <MoreVertIcon></MoreVertIcon>
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={openMenu}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <MenuItem onClick={handleClickUserDetails} disableRipple>
          <InfoIcon sx={{ marginRight: 1 }} />
          Details
        </MenuItem>
        <UpdateUserDialog user={user} />
        {license ? (
          license.licenseCanceled === false && <CancelLicenseDialog license={license} />
        ) : (
          <AssignLicenseDialog user={user} />
        )}
        <DeleteUserDialog user={user} />
      </Menu>
    </>
  )
}
